import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { trackContactBlockShow } from './tracking';
import { Agents } from '../../components/Agents';
import { getBuilders, getNewbuildingId, getSellers } from '../../selectors/newbuilding';

export function AgentsContainer() {
  const sellers = useSelector(getSellers);
  const builders = useSelector(getBuilders);
  const newbuildingId = useSelector(getNewbuildingId);

  const isAnyActiveBuilder = builders.some(builder => builder.showPhone && builder.phone?.number);

  const showHandler = React.useCallback(() => {
    trackContactBlockShow(newbuildingId, 'agents');
  }, [newbuildingId]);

  if (sellers.length === 0) {
    return null;
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={showHandler}>
      <Agents sellers={sellers} title={isAnyActiveBuilder ? 'Дополнительные продавцы' : 'Кто продаёт квартиры'} />
    </ActionAfterViewObserver>
  );
}
